// Global
export const UNLOCK_FULL_ACCESS_MODAL_NAME = 'unlock-full-access-modal'
export const USER_PROFILING_WIZARD_MODAL_NAME = 'user-profiling-wizard-modal'
export const USER_POST_PURCHASE_PROFILING_WIZARD_MODAL_NAME =
  'user-post-purchase-profiling-wizard-modal'
export const RECORDING_FEATURE_PRESENTATION_MODAL_NAME =
  'recording-feature-presentation-modal'
export const USER_PROFILE_COMPLETE_MODAL_NAME = 'user-profile-complete-modal'
export const CALENDAR_SYNC_PROMPT_MODAL_NAME = 'calendar-sync-prompt-modal'
export const FEATURE_ANNOUNCEMENT_MODAL_NAME = 'feature-announcement-modal'
export const ROADMAP_INTRO_MODAL_NAME = 'roadmap-intro-modal'
export const APPLICANT_NEXT_STEPS_MODAL_NAME = 'applicant-next-steps-modal'
// sessionStorage key: the popup rendered in this tab. Stops a re-open on a
// full reload before the server stamp lands.
export const CALENDAR_SYNC_PROMPT_SESSION_KEY = 'calendar-sync-prompt-shown'

// Mentor profile
export const EDIT_AVATAR_MODAL_NAME = 'edit-avatar-modal'
export const EDIT_PROFESSION_TITLE_MODAL_NAME = 'edit-profession-title-modal'
export const EDIT_BIOGRAPHY_MODAL_NAME = 'edit-biography-modal'
export const ADD_SPECIALTY_MODAL_NAME = 'add-specialty-modal'
export const ADD_TOOL_MODAL_NAME = 'add-tool-modal'

// Mentee profile
export const EDIT_POSITION_MODAL_NAME = 'edit-position-modal'
export const ADD_STARTUP_MODAL_NAME = 'add-startup-modal'
export const EDIT_SKILLS_MODAL_NAME = 'edit-skills-modal'
export const EDIT_CHALLENGES_MODAL_NAME = 'edit-challenges-modal'
export const EDIT_INTERESTS_MODAL_NAME = 'edit-interests-modal'

// Opportunities
export const OPPORTUNITIES_ACCESS_DENIED_MODAL_NAME =
  'opportunities-access-denied-modal'
